import React from "react"
import type { Dispatch } from "react"
import type { HistoricoCaixaModel } from "../models/historicoCaixaModel"
import { HistoricoCaixaInicial } from "../models/historicoCaixaModel"
import { historicoCaixaReducer } from "./historicoCaixaReducer"
import type { HistoricoCaixaActions } from "./historicoCaixaActions"

type HistoricoCaixaContextType = {
    dados: HistoricoCaixaModel
    dispatch: Dispatch<HistoricoCaixaActions>
    erroCarregamento: string | null
    dataInicio: string
    dataFim: string
    setDataInicio: (data: string) => void
    setDataFim: (data: string) => void
    recarregar: (dataInicio?: string, dataFim?: string) => void
}

export const HistoricoCaixaContext = React.createContext<HistoricoCaixaContextType>({
    dados: HistoricoCaixaInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    dataInicio: "",
    dataFim: "",
    setDataInicio: () => undefined,
    setDataFim: () => undefined,
    recarregar: () => undefined,
})
